import styled, { css } from 'styled-components';

export const Page = styled.div`
	padding: 32px 40px;
	max-width: 1400px;
	margin: 0 auto;
`;

export const Title = styled.h1`
	font-size: 28px;
	font-weight: 600;
	margin: 0 0 8px;
`;

export const Subtitle = styled.p`
	font-size: 14px;
	color: #6b7280;
	margin: 0 0 24px;
`;

export const StepperBar = styled.ol`
	display: flex;
	list-style: none;
	padding: 0;
	margin: 0 0 32px;
	gap: 4px;
	flex-wrap: wrap;
`;

export const StepPill = styled.li<{ active: boolean; done: boolean }>`
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 8px 14px;
	border-radius: 999px;
	font-size: 13px;
	background: ${({ active, done }) => (active ? '#111827' : done ? '#10b98120' : '#f3f4f6')};
	color: ${({ active, done }) => (active ? '#fff' : done ? '#065f46' : '#6b7280')};
	font-weight: ${({ active }) => (active ? 600 : 400)};
`;

export const Card = styled.section`
	background: #fff;
	border: 1px solid #e5e7eb;
	border-radius: 12px;
	padding: 24px;
	margin-bottom: 16px;
`;

export const CardTitle = styled.h2`
	font-size: 18px;
	font-weight: 600;
	margin: 0 0 8px;
`;

export const CardDescription = styled.p`
	font-size: 13px;
	color: #6b7280;
	margin: 0 0 16px;
`;

export const Row = styled.div`
	display: flex;
	gap: 16px;
	align-items: center;
	margin-bottom: 12px;
	flex-wrap: wrap;
`;

export const Label = styled.label`
	display: flex;
	flex-direction: column;
	gap: 4px;
	font-size: 13px;
	color: #374151;
	flex: 1 1 220px;

	span.req {
		color: #dc2626;
		margin-left: 2px;
	}
`;

export const Input = styled.input`
	padding: 8px 10px;
	border: 1px solid #d1d5db;
	border-radius: 6px;
	font-size: 14px;
	background: #fff;
	&:focus {
		outline: none;
		border-color: #6366f1;
	}
`;

export const Select = styled.select`
	padding: 8px 10px;
	border: 1px solid #d1d5db;
	border-radius: 6px;
	font-size: 14px;
	background: #fff;
	&:focus {
		outline: none;
		border-color: #6366f1;
	}
`;

export const Button = styled.button<{ variant?: 'primary' | 'secondary' | 'ghost' | 'danger' }>`
	padding: 10px 16px;
	border-radius: 8px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	border: 1px solid transparent;
	transition: opacity 0.15s;

	${({ variant }) => {
		switch (variant) {
			case 'secondary':
				return css`
					background: #fff;
					border-color: #d1d5db;
					color: #111827;
				`;
			case 'ghost':
				return css`
					background: transparent;
					color: #4b5563;
				`;
			case 'danger':
				return css`
					background: #dc2626;
					color: #fff;
				`;
			default:
				return css`
					background: #111827;
					color: #fff;
				`;
		}
	}}

	&:disabled {
		opacity: 0.4;
		cursor: not-allowed;
	}
`;

export const Footer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 24px;
	gap: 12px;
`;

export const DropZone = styled.div<{ dragging: boolean }>`
	border: 2px dashed ${({ dragging }) => (dragging ? '#6366f1' : '#d1d5db')};
	background: ${({ dragging }) => (dragging ? '#eef2ff' : '#fafafa')};
	border-radius: 12px;
	padding: 48px 24px;
	text-align: center;
	cursor: pointer;
	transition: all 0.2s;
`;

export const Table = styled.table`
	width: 100%;
	border-collapse: collapse;
	font-size: 13px;

	th,
	td {
		padding: 8px 10px;
		text-align: left;
		border-bottom: 1px solid #f1f5f9;
		vertical-align: top;
	}
	th {
		background: #f9fafb;
		font-weight: 600;
		color: #374151;
		position: sticky;
		top: 0;
	}
`;

export const ScrollContainer = styled.div`
	max-height: 480px;
	overflow: auto;
	border: 1px solid #e5e7eb;
	border-radius: 8px;
`;

export const ErrorPill = styled.span`
	display: inline-block;
	padding: 2px 8px;
	border-radius: 999px;
	background: #fee2e2;
	color: #991b1b;
	font-size: 11px;
	font-weight: 500;
	margin-right: 4px;
`;

export const WarningPill = styled.span`
	display: inline-block;
	padding: 2px 8px;
	border-radius: 999px;
	background: #fef3c7;
	color: #92400e;
	font-size: 11px;
	font-weight: 500;
	margin-right: 4px;
`;

export const SuccessPill = styled.span`
	display: inline-block;
	padding: 2px 8px;
	border-radius: 999px;
	background: #d1fae5;
	color: #065f46;
	font-size: 11px;
	font-weight: 500;
`;

export const Stat = styled.div`
	flex: 1 1 120px;
	background: #f9fafb;
	border-radius: 8px;
	padding: 16px;

	span.label {
		display: block;
		font-size: 12px;
		color: #6b7280;
		margin-bottom: 4px;
	}
	span.value {
		font-size: 22px;
		font-weight: 600;
		color: #111827;
	}
`;

export const Checkbox = styled.label`
	display: inline-flex;
	align-items: center;
	gap: 8px;
	font-size: 14px;
	cursor: pointer;

	input {
		width: 16px;
		height: 16px;
	}
`;
